export async function wait(ms: number) {
	// The callback wrapper keeps the promise resolver compatible with every
	// setTimeout signature this shared file is compiled against (bun, DOM).
	await new Promise<void>((resolve) => setTimeout(() => resolve(), ms));
}
